<template>

    <!--<div>-->
    <!--<Header/>-->
    <!--<template>-->
    <div id="air-quality">
        <div class="content" v-if="!loading">
            <div class="head">
                <div class="img-wrap">
                    <!--<img :src="imgUrl" />-->
                    <div class="top">
                        <div class="left">
                            <a-progress
                                    type="dashboard"
                                    strokeColor="#FFFFFF"
                                    :percent="100"
                                    :format="()=>data.quality.AQI"
                            />
                            <span class="text f18">AQI值</span>
<!--                            <p class="title f17">全国 <span @click="goRank" style="color:#29db26;cursor: pointer">排名</span> 第{{data.quality.aqiRank}}位</p>-->
                            <p class="title f17">全国 第{{data.quality.aqiRank}}位</p>
                        </div>
                        <div class="right">
                            <a-progress
                                    class="samll"
                                    type="dashboard"
                                    strokeColor="#FFFFFF"
                                    :percent="100"
                                    :format="()=>data.quality.primaryPoll"
                            />
                            <span class="text">首要污染物</span>
                            <p class="title f17" style="left:-20px;">{{nowDate}}</p>
                        </div>
                    </div>
                </div>
                <div class="btn-wrap">
                    <div
                            v-for="(item,index) in btnArr"
                            :key="index"
                            class="btn-item"
                            :class="{active: activeIndex === index}"
                            @click="changeTab(index)"
                    >
                        <div class="round f18">
                            {{item.val}}
                        </div>
                        <p class="f18 text">{{item.label}}</p>
                    </div>
                </div>
            </div>
            <div class="chart-content">
                <div id="echarts" ref="echarts" v-if="!noChartState">

                </div>
                <a-empty style="height:300px;padding:100px;" v-else description="暂无图表数据"/>
            </div>
        </div>
    </div>
    <!--<Footer />-->
    <!--</template>-->
    <!--</div>-->

</template>

<script>
    import UrlApi from "@/utils/UrlApi.js";
    import moment from 'moment';
    import Echarts from "echarts";
    // import Header from "../components/header/Header";
    // import Footer from "../components/Footer";
    export default {
        name: "AirQuality",
        components: {
            // Header,
            // Footer
        },
        data() {
            return {
                loading: true,
                imgUrl: null,
                data: null,
                chartData: null,
                btnArr: [],
                activeIndex: 0,
                nowDate: null,
                myChart: null,
                chartOption: null,
                noChartState: false
            };
        },
        mounted() {
            this.noChartState = false;
            this.getData();
        },
        methods: {
            changeTab(index) {
                this.activeIndex = index;
                this.initEchart();
            },
            initEchart() {
                if (this.noChartState) {
                    return
                }
                if (!this.myChart) {
                    this.myChart = Echarts.init(document.getElementById('echarts'));
                }
                let yField = this.btnArr[this.activeIndex].label.toLowerCase();
                yField = yField.replace(".", "");
                let xAxisData = [];
                let seriesData = [];
                this.chartData.forEach(item => {
                    xAxisData.push(item.station);
                    seriesData.push(item[yField]);
                })
                let option = {
                    color: ['#70D7E0'],
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                        }
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: [
                        {
                            type: 'category',
                            data: xAxisData,
                            axisTick: {
                                alignWithLabel: true
                            },
                            axisLabel: {
                                interval: 0,
                                formatter: function (value) {
                                    return value.split("").join("\n");
                                },
                                textStyle: {
                                    color: '#484848',  //更改坐标轴文字颜色
                                    fontSize: 14     //更改坐标轴文字大小
                                }
                            }
                        }
                    ],
                    yAxis: [
                        {
                            show: false,
                            type: 'value',
                            splitLine: {
                                show: false
                            }

                        }
                    ],
                    series: [
                        {
                            name: this.btnArr[this.activeIndex].label,
                            type: 'bar',
                            barWidth: '60%',
                            data: seriesData,
                            itemStyle: {
                                normal: {
                                    label: {
                                        show: true,
                                        position: 'top',
                                        textStyle: {
                                            color: '#70D7E0',
                                            fontSize: 15
                                        }
                                    }
                                }
                            }
                        },
                    ]
                };
                this.myChart.setOption(option);
            },
            // 获取数据
            getData() {
                let url1 = UrlApi.airData;
                let url2 = UrlApi.airLastDatas;
                let gpsState = this.$store.getters.getGpsState;
                let params1 = {
                    city: gpsState.city,
                    cityAlias: gpsState.city
                }
                let params2 = {
                    city: gpsState.city
                }
                let p1 = new Promise((resolve) => {
                    this.$http.get(url1, {
                        params: params1
                    }).then(res => {
                        // console.log(res)
                        resolve(res);
                    })
                })
                let p2 = new Promise((resolve) => {
                    this.$http.get(url2, {
                        params: params2
                    }).then(res => {
                        // console.log(res)
                        resolve(res);
                    })
                })
                Promise.all([p1, p2]).then((result) => {
                    // console.log(result)
                    this.initData(result)
                })
            },
            // 获取最新数据
            initData(result) {
                this.data = result[0].data.data;
                this.chartData = result[1].data.data.list;
                if (!this.chartData || !this.chartData.length) {
                    this.noChartState = true;
                }

                // console.log(this.data)
                // console.log(this.chartData)


                // this.imgUrl = UrlApi.imgIconRoot+this.data.weather.weatherIcon;
                this.nowDate = moment(this.data.quality.timePoint).format("YYYY-MM-DD HH 时发布");
                this.btnArr = [
                    // {label: "AQI", val: this.data.quality.AQI}
                ];
                for (let item in this.data.quality.factors) {
                    this.btnArr.push({
                        label: item,
                        val: this.data.quality.factors[item]
                    })
                }
                this.btnArr.push(
                    {label: "AQI", val: this.data.quality.AQI}
                )

                this.loading = false;
                this.$nextTick(() => {
                    this.initEchart();
                })
            },


            goRank(){
                this.$router.push({name:'AirRank'})
            },


        }
    }

</script>
<style lang="less" scoped>
    #air-quality {
        width: 100%;
        margin: 0 auto;
        min-height: calc(100vh - 81px);
        height: auto;
        background-color: #ffffff;
        .content {
            min-height: 100%;
            background-color: #ffffff;
            .head {
                .img-wrap {
                    width: 100%;
                    position: relative;
                    top: 0;
                    left: 0;
                    background-color: rgba(42, 72, 43, 0.78);
                    img {
                        display: block;
                        width: 100%;
                        height: 165px;
                    }
                    .top {
                        /*position: absolute;*/
                        /*top: 18px;*/
                        /*left: 0px;*/
                        display: flex;
                        justify-content: center;
                        width: 100%;
                        padding: 24px 0 48px 0;
                        & > div {
                            margin: 0 10%;
                            position: relative;
                            .text {
                                position: absolute;
                                top: 20%;
                                left: 0%;
                                text-align: center;
                                width: 100%;
                                color: #ffffff;
                            }
                            .title {
                                position: absolute;
                                bottom: -30px;
                                left: 0%;
                                text-align: center;
                                width: 100%;
                                color: #ffffff;
                                white-space: nowrap;
                            }
                        }
                    }
                }
                .btn-wrap {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-flow: row nowrap;
                    padding: 20px 0;
                    .btn-item {
                        text-align: center;
                        cursor: pointer;
                        &:hover > .text {
                            color: #66CD00;
                        }
                        &.active {
                            .text {
                                color: #66CD00;
                            }
                        }
                        .round {
                            width: 60px;
                            height: 60px;
                            text-align: center;
                            line-height: 60px;
                            border-radius: 100%;
                            margin: 0 20px;
                            background-color: #70D7E0;
                            color: #ffffff;
                            position: relative;
                        }
                        .text {
                            padding-top: 10px;
                        }
                    }
                }
            }
            .chart-content {
                #echarts {
                    width: 60%;
                    height: 480px;
                    margin: 0 auto;
                }
            }
        }
    }
</style>
<style lang="less">
    #air-quality {
        .ant-progress-text {
            font-size: 30px;
            color: #ffffff;
            top: 60%;
        }
        .samll .ant-progress-text {
            font-size: 13px;
        }
    }
</style>
